// @TODO <HEALTH2019>
App.factory('zochaReportService', ['$q', 'baseService', 'Config', '$rootScope', function ($q, baseService, Config, $rootScope) {
    function ZochaReportService() {
        var reportTypes = {
            lifeInsurance: 'zycie',
            insurance: 'zdrowotne',
            healthInsurance: 'zdrowotne',
        };

        this.prepareReportName = function (report, type) {
            var typeView = reportTypes[type] || '';
            var dateView = moment(report.creationTime).format('DD_MM_YYYY');
            var company = $rootScope.CONFIGURATOR.companyCodename;
            return 'raport_' + company + '_' + typeView + '_' + dateView + '.xlsx';
        };

        this.dataListHealth = function (data) {
            return baseService.post(Config.API_URL + '/zocha/healthInsurance/report/list', data).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };
        this.getReportHealth = function (id) {
            return baseService.download(Config.API_URL + '/zocha/healthInsurance/report/' + id + '/excel').then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };
        this.generateHealth = function (type) {
            return baseService.get(Config.API_URL + '/zocha/healthInsurance/report/generate/' + type).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        // deduction
        this.dataHealthDeductionReportList = function (data) {
            return baseService.post(Config.API_URL + '/zocha/healthInsurance/deduction/list', data).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.dataHealthDeductionChangesReportList = function (data) {
            return baseService.post(Config.API_URL + '/zocha/healthInsurance/change/list', data).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.generateHealthDeductionReport = function (data) {
            return baseService.post(Config.API_URL + '/zocha/healthInsurance/deduction/generate', data).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.generateHealthDeductionChangesReport = function (data) {
            return baseService.post(Config.API_URL + '/zocha/healthInsurance/change/generate', data).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.getHealthDeductionReport = function (criteria) {
            return baseService.download(Config.API_URL + '/zocha/healthInsurance/deduction/' + criteria.id + '/' + criteria.method).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.getHealthDeductionChangesReport = function (criteria) {
            return baseService.download(Config.API_URL + '/zocha/healthInsurance/change/' + criteria.id + '/' + criteria.method).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };
// @TODO </HEALTH2019>

        this.dataList = function (data) {
            return baseService.post(Config.API_URL + '/zocha/report/list', data).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.generate = function (type) {
            return baseService.get(Config.API_URL + '/zocha/report/generate/' + type).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.getReport = function (id) {
            return baseService.download(Config.API_URL + '/zocha/report/' + id + '/excel').then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        // deduction
        this.dataLifeDeductionReportList = function (data) {
            return baseService.post(Config.API_URL + '/zocha/report/lifeInsurance/deduction/list', data).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.generateLifeDeductionReport = function (data) {
            return baseService.post(Config.API_URL + '/zocha/report/lifeInsurance/deduction/generate', data).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.getLifeDeductionReport = function (criteria) {
            return baseService.download(Config.API_URL + '/zocha/report/lifeInsurance/deduction/' + criteria.id + '/' + criteria.method).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        // entered
        this.dataLifeEnteredReportList = function (data) {
            return baseService.post(Config.API_URL + '/zocha/report/lifeInsurance/entered/list', data).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.generateLifeEnteredReport = function (data) {
            return baseService.post(Config.API_URL + '/zocha/report/lifeInsurance/entered/generate', data).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.getLifeEnteredReport = function (criteria) {
            return baseService.download(Config.API_URL + '/zocha/report/lifeInsurance/entered/' + criteria.id + '/' + criteria.method).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.getEmployerHealthInsurancePzuwReports = function (criteria) {
            return baseService.get(`${Config.API_URL}/employer/healthInsurance/pzuw/report`, criteria)
                .then(function (success) {
                    return success;
                }, function (error) {
                    return error;
                });
        };

        this.generateEmployerHealthInsurancePzuwReport = function (data) {
            return baseService.post(`${Config.API_URL}/employer/healthInsurance/pzuw/report`, data)
                .then(function (success) {
                    return success;
                }, function (error) {
                    return error;
                });
        };

        this.downloadEmployerHealthInsurancePzuwReport = function (id) {
            return baseService.download(`${Config.API_URL}/employer/healthInsurance/pzuw/report/${id}/excel`)
                .then(function (success) {
                    return success;
                }, function (error) {
                    return error;
                });
        };
    }

    return new ZochaReportService();
}]);
